import Section from '../../../components/Section';
import Indicator from '../../../components/Indicator';
import {IIndicatorData} from '../../../utils/types';

interface Props {
    data: IIndicatorData | undefined;
}

const FruitoriSection = ({data}: Props) => (
    <Section title='I. TASSO DI RAGGIUNGIMENTO DEI FRUITORI ATTESI'>
        <Indicator
            roman=''
            title='Tasso di raggiungimento dei fruitori attesi a confronto con la media'
            tooltip="Il grafico mostra la percentuale di fruitori effettivamente raggiunti rispetto al numero di fruitori attesi da tutte le iniziative del vostro progetto, a confronto con la media dello stesso valore per tutti i progetti. La percentuale media è ottenuta sommando le percentuali di fruitori raggiunti rispetto ai fruitori attesi e dividendo il risultato per il numero totale di progetti."
            data={data ?? {uoa: null, average: null}}
            maxOverride={100}
        />
    </Section>
);

export default FruitoriSection;
